import { styled } from "@mui/material/styles";

export const BreadcrumbArea = styled("div")(({ theme }) => ({
  paddingTop: 10,
  paddingBottom: 10,
  color: theme.custom.colors.mediGray,
  fontSize: "small",
  borderBottom: `1px solid ${theme.custom.colors.mediLightGray}`,
  background: "white",
  flexShrink: 0,
  boxShadow: "0px 2px 3px rgb(174 188 197 / 50%)",
  "& a": {
    color: theme.custom.colors.mediMagenta,
    "&:hover, &:focus, &:active, &:visited": {
      textDecoration: "none",
      color: theme.custom.colors.mediMagenta,
    },
  },
}));
